import axios from "../../utils/axios";
import { buildQueryStringList } from "../../utils/stringUtils";
import type { SaveShareGroupRequest, ShareGroupDTO } from "../types/shareGroupDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchShareGroups = (siteExternalIds: string[]) => {
    const queryString = buildQueryStringList("siteExternalIds", siteExternalIds);

    return axios.get<ShareGroupDTO[]>(`${apiUrl}/ShareGroup/ForSites${queryString}`);
};

// Create and update share one endpoint; the account is resolved server-side.
const saveShareGroup = (group: SaveShareGroupRequest) =>
    axios.post<ShareGroupDTO>(`${apiUrl}/ShareGroup/Save`, {
        id: group.id,
        name: group.name,
        siteExternalId: group.siteExternalId,
        isActive: group.isActive,
        members: group.members,
    });

const deleteShareGroup = (id: number) => axios.delete<void>(`${apiUrl}/ShareGroup/${id}`);

const shareGroupService = {
    fetchShareGroups,
    saveShareGroup,
    deleteShareGroup,
};

export default shareGroupService;
